// ABOUTME: SPEC-53 — mounts the static collection stage over the (hidden, paused) reel: the carousel,
// ABOUTME: and the piece card when a piece is open. Renders nothing while the stage is the reel.
//
// Z-ORDER: `STAGE_Z` (21) sits one above the Projectionist container (20) and below everything
// else — the stage overlays' portal (62), the black fade (63), the footer (65) and the rail (80) —
// so the chrome stays interactive on top of it (owner A1). See useStageTransition.js for the map.

import React from 'react';
import CollectionStage from './CollectionStage';
import CollectionPieceCard from './CollectionPieceCard';
import { Stage } from './stageReducer';

export const STAGE_Z = 21;

const holds = (rows, id) => Array.isArray(rows) && id != null && rows.some((r) => r?.id === id);

/**
 * @param {{
 *   state: object, composition: 'desktop'|'mobile',
 *   onSelectSlot: (slot: object) => void,
 *   wishlistItems: object[], cartItems: object[],
 *   onToggleWishlist: (p: object) => void, onAddToBag: (p: object) => void, onBackToReel: () => void,
 *   onGalleryIndexChange: (i: number) => void,
 *   scrollCommand: object|null, onScrollStateChange: (s: object) => void,
 *   backLabel: string,
 *   onClosePiece?: () => void,
 * }} props
 */
export default function StageHost({
  state, composition, onSelectSlot, wishlistItems, cartItems, onToggleWishlist, onAddToBag,
  onBackToReel, onGalleryIndexChange, scrollCommand, onScrollStateChange, backLabel, onClosePiece,
}) {
  if (!state || state.stage === Stage.REEL) return null;
  const product = state.stage === Stage.PIECE ? state.product : null;
  return (
    <div
      data-testid="collection-stage-root"
      data-stage={state.stage}
      style={{ position: 'fixed', inset: 0, zIndex: STAGE_Z, background: '#000' }}
    >
      <CollectionStage collection={state.collection} onSelect={onSelectSlot} />
      {/* Dims/blocks the carousel behind the open card (client request) — scoped to THIS z-21 box
          only, painted between the carousel and the card, so it never reaches the rail (z-80),
          footer (z-65) or portal (z-62), which owner ruling A1 requires to stay interactive over
          the whole stage regardless of what the stage itself is showing. No onClick: the card's
          own X (piece-close) is the only close affordance (client correction 2026-09-14) — a
          click-to-dismiss here was landing on the carousel's own tap zone underneath as the panel
          closed out from under the pointer. This div's only job is to absorb the click, not act
          on it. */}
      {product && (
        <div data-testid="piece-backdrop" className="absolute inset-0 bg-black/40" style={{ pointerEvents: 'auto' }} />
      )}
      {product && (
        <CollectionPieceCard
          product={product}
          collectionTitle={state.collection?.title}
          backLabel={backLabel}
          wishlisted={holds(wishlistItems, product.id)}
          inBag={holds(cartItems, product.id)}
          onToggleWishlist={onToggleWishlist}
          onAddToBag={onAddToBag}
          onBackToReel={onBackToReel}
          onClose={onClosePiece}
          galleryIndex={state.galleryIndex}
          onGalleryIndexChange={onGalleryIndexChange}
          scrollCommand={scrollCommand}
          onScrollStateChange={onScrollStateChange}
          composition={composition}
        />
      )}
    </div>
  );
}
